import { Typography, Grid, Paper, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { useEffect } from "react";
import useNarrativeDisplayContainer from "./hooks/useNarrativeDisplayContainer";
import formatDate from "../../../utils/dateFormatter";
import GlowButton from "../../custom/GlowButton";
import NarrativeAnalysisContainer from "./NarrativeAnalysisContainer";

const NarrativeDisplayItem = styled(Paper)(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.palette.text.secondary,
}));

const NarrativeDisplayContainer = ({
  narrativeData,
  creationControlsLocked,
  setCreationControlsLocked,
}) => {
  const { teacherName, teacherNameLookup } = useNarrativeDisplayContainer();
  const theme = useTheme();

  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    teacherNameLookup(narrativeData.teacherId);
  }, []);

  return (
    <Grid item container direction="column">
      <Grid item>
        <NarrativeDisplayItem elevation={8}>
          <Grid item container direction="column" sx={{ padding: "20px" }}>
            <Grid item container direction="row" justifyContent="space-between">
              <Grid item container direction="column" sm={6}>
                <Grid item>
                  <Typography>{`Written By: ${
                    teacherName ? `${teacherName}` : ""
                  }`}</Typography>
                </Grid>
                <Grid item>{`Created On: ${formatDate(
                  narrativeData.createdOn
                )}`}</Grid>
              </Grid>
              <Grid
                item
                container
                direction="column"
                sm={6}
                align={smDown ? "left" : "right"}
              >
                <Grid item>
                  {narrativeData.isPublished ? "Published" : "Draft"}
                </Grid>
                <Grid item>
                  {narrativeData.lastEditedOn
                    ? `Last Edited On: ${formatDate(
                        narrativeData.lastEditedOn
                      )}`
                    : `Not edited`}
                </Grid>
              </Grid>
            </Grid>
            <NarrativeAnalysisContainer
              narrativeData={narrativeData}
              creationControlsLocked={creationControlsLocked}
              setCreationControlsLocked={setCreationControlsLocked}
            />
          </Grid>
        </NarrativeDisplayItem>
      </Grid>
    </Grid>
  );
};

export default NarrativeDisplayContainer;
